/* src/app/components/control-module/comments/comments.component.css */
.comment-recipient {
  background-color: rgba(159, 186, 201, 0.74);
  padding: 5px;
  margin-right: 5px;
  border-radius: 3px;
}
/*# sourceMappingURL=comments.component.css.map */
